// client/api/services/adminFiatPayoutService.ts
// KX-22 (model A) — admin fiat payout list + lifecycle. Completing a payout posts
// the idempotent ledger debit on the backend; the UI only flips the status.
import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export interface AdminPayout {
  id: string;
  payoutId: string;
  user: { id?: string; name: string; email: string };
  amount: number;
  currency: string;
  date?: string;
  status: string;
  rejectionReason?: string | null;
}

export interface AdminPayoutPage {
  payouts: AdminPayout[];
  pagination: { total?: number; page?: number; totalPages?: number };
}

export const listFiatPayouts = async (params?: {
  status?: string;
  page?: number;
  limit?: number;
}): Promise<AdminPayoutPage> => {
  const res = await apiClient.get(ENDPOINTS.ADMIN.FIAT_PAYOUTS, { params });
  const d = res.data?.data;
  return { payouts: d?.payouts || [], pagination: d?.pagination || {} };
};

export const updateFiatPayoutStatus = async (
  id: string,
  status: "approved" | "processing" | "completed" | "rejected",
  opts?: { rejectionReason?: string; transactionHash?: string }
): Promise<{ success?: boolean; message?: string; code?: string }> => {
  const res = await apiClient.patch(ENDPOINTS.ADMIN.FIAT_PAYOUT_STATUS(id), { status, ...opts });
  return res.data;
};
